export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export const CREATE_SUBSCRIPTION_FAIL = 'CREATE_SUBSCRIPTION_FAIL';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS';

export const CANCEL_SUBSCRIPTION_REQUEST = 'CANCEL_SUBSCRIPTION_REQUEST';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_FAIL = 'CANCEL_SUBSCRIPTION_FAIL';

export const CREATE_SUBSCRIPTION_TICKET = 'CREATE_SUBSCRIPTION_TICKET';
export const EMPTY_SUBSCRIPTION_TICKET = 'EMPTY_SUBSCRIPTION_TICKET';

export const FETCH_SUBSCRIPTIONS_REQUEST = 'FETCH_SUBSCRIPTIONS_REQUEST';
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'FETCH_SUBSCRIPTIONS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_FAILURE = 'FETCH_SUBSCRIPTIONS_FAILURE';

export const FETCH_FORECAST_REQUEST = 'FETCH_FORECAST_REQUEST';
export const FETCH_FORECAST_SUCCESS = 'FETCH_FORECAST_SUCCESS';
export const FETCH_FORECAST_FAILURE = 'FETCH_FORECAST_FAILURE';
export const FETCH_FORECAST_CANCEL = 'FETCH_FORECAST_CANCEL';

export const FETCH_SUBSCRIPTION_LOG_REASONS_REQUEST = 'FETCH_SUBSCRIPTION_LOG_REASONS_REQUEST';
export const FETCH_SUBSCRIPTION_LOG_REASONS_SUCCESS = 'FETCH_SUBSCRIPTION_LOG_REASONS_SUCCESS';
export const FETCH_SUBSCRIPTION_LOG_REASONS_FAILURE = 'FETCH_SUBSCRIPTION_LOG_REASONS_FAILURE';

export const SNOOZE_SUBSCRIPTION_REQUEST = 'SNOOZE_SUBSCRIPTION_REQUEST';
export const SNOOZE_SUBSCRIPTION_SUCCESS = 'SNOOZE_SUBSCRIPTION_SUCCESS';
export const SNOOZE_SUBSCRIPTION_FAILURE = 'SNOOZE_SUBSCRIPTION_FAILURE';
export const SNOOZE_SUBSCRIPTION_AUTHENTICATION_FAILURE =
  'SNOOZE_SUBSCRIPTION_AUTHENTICATION_FAILURE';

export const START_SUPPLEMENTS_CONSULTATION_FROM_UPSELL =
  'START_SUPPLEMENTS_CONSULTATION_FROM_UPSELL';
